customElements.get("media-gallery") || customElements.define("media-gallery", class extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      liveRegion: this.querySelector('[id^="GalleryStatus"]'),
      viewer: this.querySelector('[id^="GalleryViewer"]'),
      thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
    };
    this.mql = window.matchMedia("(min-width: 750px)");
    
    if (this.elements.thumbnails) {
      this.elements.viewer.addEventListener("slideChanged", debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll("[data-target]").forEach(mediaToSwitch => {
        mediaToSwitch.querySelector("button").addEventListener("click", this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, !1));
      });
      if (this.dataset.desktopLayout.includes("thumbnail") && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    // Filter media initially on load based on default variant selected
    window.addEventListener('DOMContentLoaded', () => {
      this.filterMediaOnLoad();
    });
    // Fallback if DOMContentLoaded already fired
    if (document.readyState !== 'loading') {
      this.filterMediaOnLoad();
    }
  }

  filterMediaOnLoad() {
    const activeOptions = Array.from(document.querySelectorAll('.product-form__input input[type="radio"]:checked, .product-form__input select')).map(el => el.value);
    if (activeOptions.length > 0) {
      this.filterMedia(activeOptions);
    }
  }

  filterMedia(selectedOptions) {
    if (!selectedOptions || !selectedOptions.length) return;
    const lowercaseOptions = selectedOptions.map(o => o.toLowerCase().trim());
    const slides = this.elements.viewer.querySelectorAll('.product__media-item');
    const thumbnails = this.elements.thumbnails ? this.elements.thumbnails.querySelectorAll('.thumbnail-list__item') : [];
    
    let firstVisibleMediaId = null;

    const filterItem = (element, isThumbnail) => {
      const altText = (element.getAttribute('data-media-alt') || '').toLowerCase();
      const matches = altText.match(/#([a-zA-Z0-9_-]+)/g);
      if (!matches) {
        // Shared / General media (no hashtags) - always show
        element.style.display = '';
        if (!isThumbnail && !firstVisibleMediaId) {
          firstVisibleMediaId = element.getAttribute('data-media-id');
        }
      } else {
        // Variant specific media - check if any option matches hashtag
        const isMatch = matches.some(match => {
          const val = match.substring(1).toLowerCase().trim().replace(/_/g, ' ').replace(/-/g, ' ');
          return lowercaseOptions.some(opt => opt.replace(/_/g, ' ').replace(/-/g, ' ') === val);
        });
        
        if (isMatch) {
          element.style.display = '';
          if (!isThumbnail && !firstVisibleMediaId) {
            firstVisibleMediaId = element.getAttribute('data-media-id');
          }
        } else {
          element.style.display = 'none';
          element.classList.remove('is-active');
        }
      }
    };

    slides.forEach(slide => filterItem(slide, false));
    thumbnails.forEach(thumb => filterItem(thumb, true));

    // Update both sliders to recalculate active slides list
    if (this.elements.viewer && this.elements.viewer.resetPages) {
      this.elements.viewer.resetPages();
    }
    if (this.elements.thumbnails && this.elements.thumbnails.resetPages) {
      this.elements.thumbnails.resetPages();
    }

    if (firstVisibleMediaId) {
      this.setActiveMedia(firstVisibleMediaId, false);
    }
  }

  onSlideChanged(event) {
    const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${event.detail.currentElement.dataset.mediaId}"]`);
    this.setActiveThumbnail(thumbnail);
  }

  setActiveMedia(mediaId, prepend) {
    const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);
    if (!activeMedia) return;
    this.elements.viewer.querySelectorAll("[data-media-id]").forEach(element => {
      element.classList.remove("is-active");
    });
    activeMedia.classList.add("is-active");
    
    if (prepend) {
      activeMedia.parentElement.prepend(activeMedia);
      if (this.elements.thumbnails) {
        const activeThumbnail2 = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        if (activeThumbnail2) activeThumbnail2.parentElement.prepend(activeThumbnail2);
      }
      if (this.elements.viewer.slider) this.elements.viewer.resetPages();
    }
    
    this.preventStickyHeader();
    window.setTimeout(() => {
      if (this.elements.thumbnails && activeMedia.parentElement) {
        activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
      }
      if ((!this.elements.thumbnails || this.dataset.desktopLayout === "stacked") && activeMedia.scrollIntoView) {
        activeMedia.scrollIntoView({ behavior: "smooth" });
      }
    });
    
    this.playActiveMedia(activeMedia);
    if (!this.elements.thumbnails) return;
    
    const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
    if (activeThumbnail) {
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }
  }

  setActiveThumbnail(thumbnail) {
    if (!this.elements.thumbnails || !thumbnail) return;
    this.elements.thumbnails.querySelectorAll("button").forEach(element => element.removeAttribute("aria-current"));
    thumbnail.querySelector("button").setAttribute("aria-current", !0);
    if (!this.elements.thumbnails.isSlideVisible(thumbnail, 10) && this.elements.thumbnails.slider) {
      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }
  }

  announceLiveRegion(activeItem, position) {
    const image = activeItem.querySelector(".product__modal-opener--image img");
    if (image) {
      image.onload = () => {
        this.elements.liveRegion.setAttribute("aria-hidden", !1);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace("[index]", position);
        setTimeout(() => {
          this.elements.liveRegion.setAttribute("aria-hidden", !0);
        }, 2e3);
      };
      image.src = image.src;
    }
  }

  playActiveMedia(activeItem) {
    const deferredMedia = activeItem.querySelector(".deferred-media");
    if (deferredMedia && deferredMedia.loadContent) deferredMedia.loadContent(!1);
  }

  preventStickyHeader() {
    this.stickyHeader = this.stickyHeader || document.querySelector("sticky-header");
    if (this.stickyHeader && this.stickyHeader.dispatchEvent) {
      this.stickyHeader.dispatchEvent(new Event("preventHeaderReveal"));
    }
  }

  removeListSemantic() {
    if (this.elements.viewer.slider) {
      this.elements.viewer.slider.setAttribute("role", "presentation");
      if (this.elements.viewer.sliderItems) {
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute("role", "presentation"));
      }
    }
  }
});
